import type React from 'react';
import type { ChangeEvent } from 'react';

import { SearchIcon } from '@vlabs/icons';
import type { InputProps } from '@vlabs/uikit/components/controls/input/Input';
import { Input } from '@vlabs/uikit/components/controls/input/Input';
import { useTranslation } from 'react-i18next';

import { usePermissionTagsFilters } from './usePermissionTagsFilters';

function PermissionTagListPageSearchInput(props: InputProps): React.JSX.Element {
  const { t } = useTranslation();
  const { updateFiltersDebounced } = usePermissionTagsFilters();
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value) {
      updateFiltersDebounced({ permission_tags: e.target.value });
    } else {
      updateFiltersDebounced({ permission_tags: undefined });
    }
  };

  return (
    <Input
      icon={<SearchIcon />}
      onChange={handleChange}
      placeholder={t('entities:permission_tags_filters.permission_tags.placeholder') as unknown as string}
      {...props}
    />
  );
}

export { PermissionTagListPageSearchInput };
